import { AssetStatus } from '@hub-la/fe-asset'
import { PostResponse, PostStatus } from '@hub-la/fe-post'

export class IsPostPublishable {
  public execute(post: PostResponse) {
    return post.status === PostStatus.DRAFT && (post.isVideo ? post.cover?.status === AssetStatus.available : true)
  }
}
